var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7671 5.31722L13.7673 5.31706C14.1852 4.89897 14.6813 4.56731 15.2274 4.34104C15.7735 4.11476 16.3589 3.99829 16.95 3.99829C17.5411 3.99829 18.1265 4.11476 18.6726 4.34104C19.2187 4.56731 19.7148 4.89897 20.1327 5.31706L20.1331 5.31739C20.5511 5.73528 20.8828 6.23145 21.1091 6.77755C21.3354 7.32366 21.4518 7.90899 21.4518 8.50012C21.4518 9.09124 21.3354 9.67658 21.1091 10.2227C20.8828 10.7688 20.5511 11.265 20.1331 11.6828L20.1329 11.683L19.0729 12.743L12 19.8159L4.9271 12.743L3.8671 11.683C3.02295 10.8389 2.54871 9.69393 2.54871 8.50012C2.54871 7.3063 3.02295 6.16138 3.8671 5.31722C4.71126 4.47307 5.85618 3.99883 7.05 3.99883C8.24381 3.99883 9.38873 4.47307 10.2329 5.31722L11.2929 6.37722L12 7.08433L12.7071 6.37722L13.7671 5.31722Z",
    stroke: "#00C986",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.bd8bc9472f2d3b924389b5523625ec33.svg";
export { ForwardRef as ReactComponent };